// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__2i36C","content":"App_content__11LHs","title":"App_title__2C-7r","getStarted":"App_getStarted__15xn_","getStartedText":"App_getStartedText__3uxt5"};